//@ts-check
'use strict';

/**
 * 
 * @param {import("./card-category").CardCategoryProps} props 
 * @returns 
 */
function CardCategory(props) {
    const toolButtons = [];
    const card = $(/*html*/
        `<div class="card card-custom card-pill change-view gutter-b">
            <div class="card-header">
                <div class="card-title">
                    <h3 class="card-label">${props.caption}</h3>
                </div>
                <div class="card-toolbar">
                    <ul class="nav nav-light-success nav-bold  nav-pills categories"></ul>
                </div>
                <div class="card-toolbar">
                    <ul class="nav nav-bold nav-pills card-toolbuttons"></ul>
                </div>
            </div>
            <div class="card-body">
                <div class="tab-content"></div>
            </div>
        </div>`
    );
    const categories = props.tabs.map((tabProp) => {
        const { uuid, caption, isActive, onShownBsTab } = tabProp;
        const tab = $(/*html*/
            `<li class="nav-item">
                <a class="nav-link btn-pill btn px-2 py-0 ${isActive ? 'active' : ''}" data-toggle="tab" href="#card_tab_${uuid}">${caption}</a>
            </li>`
        );
        const showLessButton = showLessButtonTemplate(isActive);
        
        let isShowLessVisible = false;
        
        toolButtons.push(showLessButton);

        showLessButton.on('click', () => {
            card.removeClass('list-view')
        });

        tab.on('show.bs.tab', () => {
            showLessButton.removeClass('d-none');

            card.toggleClass('list-view', isShowLessVisible);
        });

        tab.on('hide.bs.tab', () => {
            isShowLessVisible = card.hasClass('list-view');
            
            showLessButton.addClass('d-none');

            card.removeClass('list-view');
        });

        if (typeof onShownBsTab == 'function') {
            tab.on('shown.bs.tab', () => {
                onShownBsTab();
            });
        }

        return tab;
    });

    const categoriesContent = props.tabs.map(({ uuid, isActive, content }) => {
        return $(/*html*/`<div class="tab-pane ${isActive ? 'active show' : ''}" id="card_tab_${uuid}" role="tabpanel">`).append(content || $());
    });

    card.find('.categories').append(categories);
    card.find('.tab-content').append(categoriesContent);
    card.find('.card-toolbuttons').css('min-width', '112px').append(toolButtons);

    return card;
}

function showLessButtonTemplate(isVisible = false) {
    return $(/*html*/
        `<a href="#" class="btn btn-link-primary font-weight-bolder show-less-items ${isVisible ? '' : 'd-none'}">
            Ver menos
            <i class="las la-times"></i>
        </a>`
    );
}

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = CardCategory
}